// utils/auth.ts
export const getAuthUser = () => {
  try {
    const storedUser = localStorage.getItem("authUser");
    if (!storedUser) return null;
    return JSON.parse(storedUser);
  } catch (error) {
    console.error("Error parsing authUser from localStorage", error);
    return null;
  }
};


export const getFileUrl = () => {
  try {
      const fileUrl = process.env.REACT_APP_FILE_URL;
      return fileUrl;
  } catch (error) {
    console.error("Error parsing authUser from localStorage", error);
    return null;
  }
};

export const getUserSubscribePlan = () => {
  try {
    const authUser = getAuthUser();
    const planCost = authUser?.user.subscribe_plan.plan_cost;
    return planCost > 0 ? 'premium' : "free"; 
  } catch (error) {
    console.error("Error getting subscribe plan from authUser", error);
    return "free";
  }
};

export const checkUserType = () => {
  try {
    const authUser = getAuthUser();
    let isReffrelUser=0;
    if(authUser.user.referral_code > 0){
        isReffrelUser=1;
    }
    return isReffrelUser;
  } catch (error) {
    console.error("Error getting subscribe plan from authUser", error);
    return "free";
  }
};



